// extracted by mini-css-extract-plugin
export default {"modalOverlay":"NJ-z","modalContent":"OJ-z","header":"PJ-z","close":"QJ-z"};